import React from 'react';
export function TopBar() {
  return <div className="bg-[#1a0a00] border-b-2 border-gold text-center py-3 px-4 text-[13px] text-gold font-bold tracking-wide sticky top-0 z-50" data-id="element-180">
      ✝️ &nbsp; MISIÓN INFLUENCIA™ &nbsp;·&nbsp; ⚠️ PRECIO DE LANZAMIENTO
      ACTIVO — Solo por tiempo limitado. Después sube. &nbsp; ✝️
    </div>;
}